export function createDriverProfileClient(transport) {
    return {
        /**
         * The drivers an operator is looking through
         *
         * Requires scope: driver-profile:read, driver-profile:workload
         */
        listDriverProfiles(operationalStatus, limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/driver-profiles",
                query: { operationalStatus: operationalStatus, limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /v1/driver-profiles
         *
         * Requires scope: driver-profile:create
         */
        createDriverProfile(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/driver-profiles",
                body,
                options,
            });
        },
        /**
         * GET /v1/driver-profiles/{driverId}
         *
         * Requires scope: driver-profile:read
         */
        getDriverProfile(driverId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/driver-profiles/${encodeURIComponent(driverId)}`,
                options,
            });
        },
        /**
         * PATCH /v1/driver-profiles/{driverId}
         *
         * Requires scope: driver-profile:update
         */
        updateDriverProfile(driverId, body, options) {
            return transport.request({
                method: "PATCH",
                path: `/v1/driver-profiles/${encodeURIComponent(driverId)}`,
                body,
                options,
            });
        },
        /**
         * Answer whether this driver profile may be part of an approved onboarding
         *
         * Requires scope: driver-profile:eligibility
         */
        getTenantsReferencesEligibility(tenantId, referenceId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/references/${encodeURIComponent(referenceId)}/eligibility`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=driver-profile.js.map